/*
  The 1:1 upsell A/B test around challenge checkout. Every checkout offers the 1:1; the arm decides where:

  - CONTROL, the default: nothing before payment; the 1:1 is offered right after the challenge is paid. Offering it
    only once the challenge is bought cannot cost the challenge sale, so a link that names no arm gets it.
  - LANDING, the test: the 1:1 is offered on the challenge's landing page (another surface), which assigns the arm and
    hands the answer over on the checkout link. An accepted 1:1 is shown at checkout and signed up after payment; a
    declined one, or a missing answer, is not offered again.

  The arm comes from the link alone: the landing page is the one place that assigns it, as a short code on the
  checkout link (`ua=l`, `ua=c`; utils/onboarding) so the link doesn't spell the test out.
*/

// The arm, as the app and its events name it.
const UpsellArm = {
  LANDING: 'landing',
  CONTROL: 'control',
};

// The arm's code on the checkout link (`ua`).
const UpsellArmLinkCode = {
  LANDING: 'l',
  CONTROL: 'c',
};

// The landing page's answer, as its code on the checkout link (`u`).
const LandingUpsellAnswer = {
  ACCEPTED: 'a',
  DECLINED: 'd',
};

/*
  Where an accepted 1:1 came from, stamped on its contract by createUpsellContract: the landing page, or the offer
  right after payment (the control arm's). Shared wire values with system2-server's UpsellSource.
*/
const UpsellSource = {
  LANDING: 'landing',
  POST_PAYMENT: 'post_payment',
};

/**
 * The visitor's arm: LANDING when the link carries its code, else CONTROL, whatever else the link says.
 *
 * @param {string} [linkArm] the `ua` link parameter
 * @returns {string} one of UpsellArm
 */
const resolveUpsellArm = (linkArm) => (
  linkArm === UpsellArmLinkCode.LANDING ? UpsellArm.LANDING : UpsellArm.CONTROL
);

export {
  UpsellArm,
  UpsellArmLinkCode,
  LandingUpsellAnswer,
  UpsellSource,
  resolveUpsellArm,
};
